/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DayInputs */

const en_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`day`)
};

const ar_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يوم`)
};

const de_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const es_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`día`)
};

const fr_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jour`)
};

const it_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`giorno`)
};

const ja_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日`)
};

const ko_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일`)
};

const pt_br_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dia`)
};

const ru_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`день`)
};

const th_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วัน`)
};

const tr_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gün`)
};

const zh_cn_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天`)
};

const zh_tw_day = /** @type {(inputs: DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`天`)
};

/**
* | output |
* | --- |
* | "day" |
*
* @param {DayInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const day = /** @type {((inputs?: DayInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DayInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_day(inputs)
	if (locale === "ar") return ar_day(inputs)
	if (locale === "de") return de_day(inputs)
	if (locale === "es") return es_day(inputs)
	if (locale === "fr") return fr_day(inputs)
	if (locale === "it") return it_day(inputs)
	if (locale === "ja") return ja_day(inputs)
	if (locale === "ko") return ko_day(inputs)
	if (locale === "pt_br") return pt_br_day(inputs)
	if (locale === "ru") return ru_day(inputs)
	if (locale === "th") return th_day(inputs)
	if (locale === "tr") return tr_day(inputs)
	if (locale === "zh_cn") return zh_cn_day(inputs)
	return zh_tw_day(inputs)
});